import React from 'react';

const SupportEvents = ({ events }) => {
    if (!events || events.length === 0) return null;

    // Helper to group options by name
    const groupOptionsByName = (options) => {
        const grouped = {};
        options.forEach(opt => {
            if (!grouped[opt.option_name]) {
                grouped[opt.option_name] = [];
            }
            grouped[opt.option_name].push(opt);
        });
        return Object.entries(grouped);
    };

    // Group events by type
    const groupedEvents = events.reduce((acc, event) => {
        const type = event.event_type || 'Other';
        if (!acc[type]) acc[type] = [];
        acc[type].push(event);
        return acc;
    }, {});

    // Sort types alphabetically
    const sortedTypes = Object.keys(groupedEvents).sort();

    return (
        <div className="space-y-6">
            <h2 className="text-xl font-bold text-gray-900 border-l-4 border-purple-500 pl-3">
                Training Events
            </h2>

            <div className="space-y-8">
                {sortedTypes.map(type => (
                    <div key={type} className="space-y-4">
                        {/* Type Header */}
                        <h3 className="text-lg font-bold text-gray-700 border-b border-gray-200 pb-2">
                            {type}
                        </h3>

                        <div className="grid gap-6">
                            {groupedEvents[type].map((event, idx) => (
                                <div key={idx} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow">
                                    {/* Event Header */}
                                    <div className="bg-gray-50 px-6 py-3 border-b border-gray-100 flex justify-between items-center">
                                        <h3 className="font-bold text-gray-800 text-lg">
                                            {event.event_name}
                                        </h3>
                                        <span className="text-xs font-semibold px-2 py-1 bg-gray-200 text-gray-600 rounded">
                                            {event.event_type}
                                        </span>
                                    </div>

                                    {/* Options List */}
                                    <div className="divide-y divide-gray-50">
                                        {groupOptionsByName(event.options).map(([optName, variants], optIdx) => (
                                            <div key={optIdx} className="p-4 sm:flex gap-4">
                                                {/* Option Name (Rendered Once) */}
                                                <div className="sm:w-1/4 mb-2 sm:mb-0 pt-1">
                                                    <div className="font-semibold text-blue-700 bg-blue-50 inline-block px-3 py-1 rounded-lg text-sm border border-blue-100">
                                                        {optName}
                                                    </div>
                                                </div>

                                                {/* Variants List */}
                                                <div className="sm:w-3/4 flex flex-col md:flex-row gap-3">
                                                    {variants.map((variant, varIdx) => (
                                                        <div
                                                            key={varIdx}
                                                            className="relative p-3 rounded-lg bg-gray-50 border border-gray-200 flex-1"
                                                        >
                                                            {/* Effects */}
                                                            <div className="space-y-1">
                                                                {variant.effects.map((effect, effIdx) => (
                                                                    <div key={effIdx} className="flex items-center text-sm text-gray-700">
                                                                        <span className={`w-2 h-2 rounded-full mr-2 flex-shrink-0 ${effect.type === 'stat' ? 'bg-green-500' :
                                                                            effect.type === 'mood' ? 'bg-yellow-500' :
                                                                                effect.type === 'skill' ? 'bg-purple-500' :
                                                                                    'bg-gray-400'
                                                                            }`}></span>

                                                                        <span className="flex-grow">
                                                                            {effect.text}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SupportEvents;
